import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useQueryWithErrorHandling } from 'customHooks/errorHandling';
import {
  COUNTRIES_DICTIONARY_QUERY,
  COUNTIES_DICTIONARY_QUERY,
  CITIES_DICTIONARY_QUERY,
  CITIZENSHIP_QUERY,
  PAGED_INDIVIDUAL_PARTNERS_QUERY
} from '../gql/queries/index';
import { useDictionary } from '../gql/hooks/useDictionary';
import FilterComponentPF from './FilterComponentPF';
import BrowserComponentPF from './BrowserComponentPF';

const PFContainer = ({ onTotalCountChange, pager, onTextFieldChange,onRefresh, setOpenModal }) => {
  const defaultIndividualPartnerFilters = {
    uniqueId: '',
    fullName: '',
    countryId: null,
    citizenshipId: null,
    nationalityId: null,
    birthDate: '',
    countyId: null,
    cityId: null,
    idSeriesAndNumber: ''
  };

  const [filters, setFilters] = useState(defaultIndividualPartnerFilters);
  const [specialFilters, setSpecialFilters] = useState({});
  const citizenships = useDictionary(CITIZENSHIP_QUERY, { variables: { search: ""} });
  const cities = useDictionary(CITIES_DICTIONARY_QUERY, { variables: { parentId: filters?.countyId } });
  const counties = useDictionary(COUNTIES_DICTIONARY_QUERY, { variables: { parentId: filters?.countryId } });
  const countries = useDictionary(COUNTRIES_DICTIONARY_QUERY);

  const { data } = useQueryWithErrorHandling(PAGED_INDIVIDUAL_PARTNERS_QUERY, {
    variables: {
      pager: {
        size: pager.pageSize,
        page: pager.page
      },
      filters
    },
    onCompleted: data => {
      onTotalCountChange(data.pagedIndividualPartners.pagination.totalCount);
    }
  });

  const onPropertyChange = (e, columnName) => {
    const updatedFilters = { ...filters, [columnName]: e };
    setSpecialFilters({ ...updatedFilters });
    setFilters(updatedFilters); 
    onRefresh();
  };
 
  const handleSaveData = idx => {
    let selectedItem = data?.pagedIndividualPartners?.values?.find((_, index) => idx === index);
    if (!selectedItem) return;
    onTextFieldChange(selectedItem.uniqueId);
    setOpenModal(false);
  };

  return (
    <Grid>
      <Grid container spacing={1}>
        <FilterComponentPF
          onPropertyChange={onPropertyChange}
          filters={filters}
          specialFilters={specialFilters}
          citizenships={citizenships.data}
          cities={cities.data}
          counties={counties.data}
          countries={countries.data}
        />
      </Grid>
      <Grid container my={2}>
        <BrowserComponentPF handleSaveData={handleSaveData} pfPartners={data?.pagedIndividualPartners?.values}></BrowserComponentPF>
      </Grid>
    </Grid>
  );
};

PFContainer.propTypes = {
  parentId: PropTypes.number,
  pager: PropTypes.object.isRequired,
  onTotalCountChange: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  onTextFieldChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired
};

export default PFContainer;
